import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Grid,
  Paper,
  FormControl,
  Select,
  MenuItem,
  ListItemText,
  Button,
  IconButton,
  InputLabel,
  OutlinedInput,
  TextField,
  CircularProgress,
  List,
  ListItem,
  ListItemButton,
  Tab,
} from "@mui/material";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DownloadIcon from "@mui/icons-material/Download";
import Cookies from "js-cookie";
import axios from "axios";
import { toast } from "react-toastify";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);

const Container = styled(Box)({
  minHeight: "100vh",
  background: "linear-gradient(135deg, #e0e7ff 0%, #a5b4fc 100%)",
  fontFamily: "'Roboto', sans-serif",
  display: "flex",
  flexDirection: "column",
});

const COLORS = {
  DARK_GRAY: "#2A2E34",
};


const CCTVDownload = () => {
  // const [currentTime, setCurrentTime] = useState("");
  // const [selectedDate, setSelectedDate] = useState(dayjs());
  // const location = useLocation();
  // const navigate = useNavigate();
  // const [loadingCameras, setLoadingCameras] = useState(false);
  // const [loadingFootage, setLoadingFootage] = useState(false);
  // const [cameras, setCameras] = useState([]);
  // const [footage, setFootage] = useState([]);
  // const [selectedCameraId, setSelectedCameraId] = useState(null);
  // const [selectedCameraname, setSelectedCameraname] = useState(null);
  // const [selectedLocation, setSelectedLocation] = useState("");
  // const [stores, setStores] = useState([]);
  // const [selectedCity, setSelectedCity] = useState("");
  // const [getdc, setGetdc] = useState([]);

  // const fetchStores = async () => {
  //   try {
  //     const response = await axios.post(
  //       "https://api.more.in/v1/vigil_portal",
  //       { dc_city: selectedCity, rawPath: "/get_locs" },
  //       {
  //         headers: {
  //           Authorization: Cookies.get("ssp_sso_token"),
  //           "content-type": "application/json",
  //         },
  //       }
  //     );
  //     if (response?.data?.status === "success") {
  //       setStores(response?.data?.message?.records);
  //     } else {
  //       toast.error(
  //         response?.data?.message ||
  //         "Something went wrong, Please try again later!",
  //         { position: "top-right" }
  //       );
  //     }
  //   } catch (err) {
  //     console.log(err);
  //     toast.error("Something went wrong, Please try again later!", {
  //       position: "top-right",
  //     });
  //   }
  // };

  // const handleLocationChange = (event) => {
  //   setSelectedLocation(event.target.value);
  //   setCameras([]);
  //   setFootage([]);
  //   setSelectedCameraId(null);
  //   setSelectedCameraname(null);
  // };

  // const handleGetDc = async () => {
  //   try {
  //     const response = await axios.post(
  //       "https://api.more.in/v1/vigil_portal",
  //       {
  //         rawPath: "/get_dc",
  //       },
  //       {
  //         headers: {
  //           Authorization: Cookies.get("ssp_sso_token"),
  //           "content-type": "application/json",
  //         },
  //       }
  //     );
  //     if (response?.data?.status === "success") {
  //       setGetdc(response?.data?.message?.records);
  //     } else {
  //       toast.error(
  //         response?.data?.message ||
  //         "Something went wrong, Please try again later!",
  //         { position: "top-right" }
  //       );
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const fetchCameras = async () => {
  //   try {
  //     setLoadingCameras(true);
  //     const formattedDate = selectedDate.format("YYYY-MM-DD").toLowerCase();
  //     const response = await axios.post(
  //       "https://api.more.in/v1/vigil_portal",
  //       { loc: selectedLocation, date: formattedDate, rawPath: "/get_drive_folders", },
  //       {
  //         headers: {
  //           Authorization: Cookies.get("ssp_sso_token"),
  //           "content-type": "application/json",
  //         },
  //       }
  //     );
  //     if (response?.data?.status === "success") {
  //       setCameras(response?.data?.body);
  //       setLoadingCameras(false);
  //     } else {
  //       setLoadingCameras(false);
  //       toast.error(
  //         response?.data?.body?.message ||
  //         "Something went wrong, Please try again later!",
  //         { position: "top-right" }
  //       );
  //     }
  //   } catch (error) {
  //     setLoadingCameras(false);
  //     toast.error("Something went wrong, Please try again later!", {
  //       position: "top-right",
  //     });
  //   }
  // };

  // const fetchFootage = async (cameraId) => {
  //   try {
  //     setLoadingFootage(true);
  //     const response = await axios.post(
  //       "https://api.more.in/v1/vigil_portal",
  //       { loc: selectedLocation, camera_folder_id: cameraId, rawPath: "/get_camera_files" },
  //       {
  //         headers: {
  //           Authorization: Cookies.get("ssp_sso_token"),
  //           "content-type": "application/json",
  //         },
  //       }
  //     );
  //     if (response?.data?.status === "success") {
  //       setLoadingFootage(false);
  //       setFootage(response?.data?.body);
  //     } else {
  //       setLoadingFootage(false);
  //       toast.error(
  //         response?.data?.body?.message ||
  //         "Something went wrong, Please try again later!",
  //         { position: "top-right" }
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error fetching footage:", error);
  //     setLoadingFootage(false);
  //     toast.error("Something went wrong, Please try again later!", {
  //       position: "top-right",
  //     });
  //   }
  // };

  // const handleFetchData = () => {
  //   if (selectedDate && selectedLocation !== "" && getdc.length > 0) {
  //     fetchCameras();
  //   }
  // };
  // const handleCameraClick = (cameraId, cameraName) => {
  //   setSelectedCameraId(cameraId);
  //   setSelectedCameraname(cameraName);
  //   fetchFootage(cameraId);
  // };
  // const handleChange = (event) => {
  //   setSelectedCity(event.target.value);
  // };

  // useEffect(() => {
  //   const updateTime = () => {
  //     const now = new Date();
  //     const day = String(now.getDate()).padStart(2, "0");
  //     const month = String(now.getMonth() + 1).padStart(2, "0");
  //     const year = now.getFullYear();
  //     const hours = String(now.getHours()).padStart(2, "0");
  //     const minutes = String(now.getMinutes()).padStart(2, "0");
  //     const seconds = String(now.getSeconds()).padStart(2, "0");
  //     const dayName = now.toLocaleString("en-US", { weekday: "short" });
  //     setCurrentTime(
  //       `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${dayName}`
  //     );
  //   };

  //   updateTime();
  //   const interval = setInterval(updateTime, 1000);
  //   return () => clearInterval(interval);
  // }, []);

  // const handleDateChange = (newDate) => {
  //   if (newDate && newDate.isValid()) {
  //     setSelectedDate(newDate);
  //     setSelectedCameraId(null);
  //     setSelectedCameraname(null);
  //     setCameras([]);
  //     setFootage([]);
  //   } else {
  //     setSelectedDate(null);
  //   }
  // };
  // const handleGoBack = () => {
  //   navigate("/cctv");
  // };
  // const handlePlayback = () => {
  //   navigate("/cctv_playback");
  // };

  // const handleDownload = async (id, loc) => {
  //   try {
  //     setLoadingCameras(true);
  //     const response = await axios.post(
  //       "https://api.more.in/v1/vigil_portal",
  //       { rawPath: "/get_gdrive_download_file", id: id, loc: loc },
  //       {
  //         headers: {
  //           Authorization: Cookies.get("ssp_sso_token"),
  //           "content-type": "application/json",
  //         },
  //       }
  //     );
  //     if (response?.data?.status === "success") {
  //       window.open(response?.data?.view_url, "_blank");
  //       setLoadingCameras(false);
  //     } else {
  //       setLoadingCameras(false);
  //       toast.error(
  //         response?.data?.message ||
  //         "Something went wrong, Please try again later!",
  //         { position: "top-right" }
  //       );
  //     }
  //   } catch (err) {
  //     setLoadingCameras(false);
  //     toast.error("Something went wrong, Please try again later!", {
  //       position: "top-right",
  //     });
  //   }
  // };

  // useEffect(() => {
  //   handleGetDc();
  // }, []);

  // useEffect(() => {
  //   if (getdc.length > 0) {
  //     fetchStores();
  //   }
  // }, [selectedCity]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: COLORS.DARK_GRAY,
        color: "white",
        textAlign: "center",
        gap: 2,
      }}
    >
      <Typography variant="h1" sx={{ fontSize: "8rem", fontWeight: 700, lineHeight: 1, color: COLORS.PRIMARY ?? "#1976d2" }}>
        404
      </Typography>
      <Typography variant="h5" sx={{ fontWeight: 500, letterSpacing: 2, textTransform: "uppercase" }}>
        Page Not Found
      </Typography>
      <Typography variant="body1" sx={{ color: "gray", maxWidth: 400 }}>
        The page you're looking for doesn't exist
      </Typography>
    </Box>
  );
};

export default CCTVDownload;
